module.exports = __webpack_public_path__ + "static/media/SMS_tr.bda11cd8.png";